import React, { useEffect } from "react";
import styles from "./ColorModeToggle.module.scss";
import useColorMode from "hooks/useColorMode";
import $ from "jquery";

export const ColorModeToggle = ({ className, style }) => {
  const { mode, toggle } = useColorMode();

  useEffect(() => {
    $("body").attr("data-bs-theme", mode);
  }, [mode]);

  return (
    <div className={[className, styles.toggle, mode === "light" ? styles.light : styles.dark].join(" ")} style={style} onClick={() => toggle()}>
      <label className={styles.switch}>
        <span className={styles.slider}>
          <p>{mode}</p>
        </span>
      </label>
    </div>
  );
};

export default ColorModeToggle;
